module.exports = __webpack_public_path__ + "static/img/qrcode.1f219ea5.png";